import moment from "moment";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import { MobileMonthSelector } from "../../../../parts/MobileMonthSelector";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import NavigationComponent from "../../calendar/components/NavigationComponent";
import { ReportsBackHandler } from "../../calendar/components/ReportsBackHandler";
import MonthSelector from "../../calendar/progress-photos/components/MonthSelector";
import MealPhotosCard from "./components/MealPhotosCard";


const MealPhotos = ({ locals, mealPhotos, startDate, endDate }) => {
  const { t } = useTranslation("athlete-portal");
  const { athlete, query, pathname, activeUser } = locals;
  const [date, setDate] = useState(moment(startDate, "YYYYMMDD"));
  const handleMonthChange = (date) => {
    setDate(date);
    submit(`/actions/refresh`, {
      method: "GET",
      body: {
        startDate: moment(date).startOf("month").format("YYYYMMDD"),
        endDate: moment(date).endOf("month").format("YYYYMMDD"),
      },
    });
  };
  const sortedPhotos = mealPhotos.days.sort((a, b) => b.utcDate - a.utcDate);
  return (
    <main role="reports-wrapper" id="progress-photos">
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(locals?.athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <NavigationComponent
        query={query}
        textKey="nav.calendarDayView"
        pathName={pathname}
        classNames="mobile-hidden"
      />
      <article role="report-content" id="meal-photos">
        <header>
          <div className="top-header only-show-mobile">
            <ReportsBackHandler title={"Meal Photos"} locals={locals} />
            <MobileMonthSelector date={date} setDate={handleMonthChange} />
          </div>
          <div className="flex gap-2 items-center">
            <h3 className="mobile-hidden">{t("mealPhotosPage.title")}</h3>
          </div>
        </header>
        <section className="flex gap-6">
          <aside className="max-w-48">
            <MonthSelector date={date} setDate={handleMonthChange} />
          </aside>
          <div className="grow">
            {sortedPhotos.map((day, index) => {
              // Error handling for missing day data
              if (!day || !day.utcDate) {
                return (
                  <article className="meal-photos-card">
                    <div className="error-message">
                      <p>Unable to load meal data</p>
                    </div>
                  </article>
                );
              }
              return (
                <MealPhotosCard
                  key={day.utcDate}
                  day={day}
                  activeUser={activeUser}
                  athlete={athlete}
                  locals={locals}
                  lastItem={index === sortedPhotos.length - 1}
                />
              );
            })}
          </div>
        </section>
      </article>
    </main>
  );
};

export default MealPhotos;
